import React, {useEffect} from "react"
import {useLocation} from "react-router-dom"

import {useKeycloak} from "@react-keycloak/web"

import Routing from "../utils/Routing"
import Loader from "./Loader"

function AuthKeyCloak({children}: any) {
    const {keycloak, initialized} = useKeycloak()
    const location = useLocation()

    const isTokenExpired = (token: string | null): boolean => {
        if (!token) return true
        const [, payload] = token.split(".")
        if (!payload) return true

        try {
            const decoded = JSON.parse(atob(payload))
            const currentTime = Math.floor(Date.now() / 1000)
            return decoded.exp <= currentTime
        } catch (error) {
            console.error("Erreur lors de la vérification du token :", error)
            return true
        }
    }

    useEffect(() => {
        const refreshToken = async (): Promise<string | null> => {
            try {
                const refreshed = await keycloak.updateToken(60) // 30 secondes avant expiration
                if (refreshed) {
                    localStorage.setItem("accessToken", keycloak.token || "")
                    return keycloak.token
                } else {
                    return keycloak.token
                }
            } catch (error) {
                return null
            }
        }

        const keyClockSessionCheck = async () => {
            if (initialized && !keycloak.authenticated && !Routing.IsOffline(location.pathname)) {
                try {
                    await keycloak.login({redirectUri: window.location.href})
                } catch (error) {
                    console.error("Erreur de connexion à Keycloak:", error)
                    // Gérer les erreurs de connexion ici de manière appropriée
                }
            } else {
                const accessToken = localStorage.getItem("accessToken")
                if (accessToken && isTokenExpired(accessToken)) {
                    try {
                        const refreshedToken = await refreshToken()
                        if (refreshedToken) {
                            localStorage.setItem("accessToken", refreshedToken)
                        }
                    } catch (error) {
                        console.error("Erreur lors du rafraîchissement du token :", error)
                    }
                }
            }
        }

        keyClockSessionCheck()
    }, [initialized, keycloak, location.pathname])

    if (Routing.IsOffline(location.pathname) || keycloak.authenticated) {
        return children
    }

    // Afficher un loader pendant la connexion
    return <Loader isLoading={true} style={{zIndex: 999999}} />
}

export default AuthKeyCloak
